export var SpmMetrics;
(function (SpmMetrics) {
    SpmMetrics["Throughput"] = "throughput";
    SpmMetrics["ErrorRate"] = "errorRate";
    SpmMetrics["Latency"] = "latency";
    SpmMetrics["HttpStatusCode"] = "httpStatusCode";
})(SpmMetrics || (SpmMetrics = {}));
//# sourceMappingURL=spm-metrics.enum.js.map